const PUBLIC_FIELDS = [
  "id", "barcode", "name", "brand", "image_url", "category", "case_upc",
  "pack_size", "unit_of_measure", "case_pack",
];

function publicPreview(product) {
  if (!product || ![product.id, product.barcode, product.name].every(
    (value) => typeof value === "string" && value.trim(),
  )) return null;
  return Object.fromEntries(PUBLIC_FIELDS.map((field) => [field, product[field]]));
}

export function sharedCatalogSearchPage(data) {
  if (!Array.isArray(data?.items) || typeof data.has_more !== "boolean"
      || !(data.next_cursor === null || (typeof data.next_cursor === "string" && data.next_cursor.trim()))
      || data.has_more !== !!data.next_cursor) throw new Error("Invalid shared catalog response");
  const items = data.items.map(publicPreview);
  if (items.some((item) => !item)) throw new Error("Invalid shared catalog product");
  return { items, nextCursor: data.next_cursor };
}

export function unownedSharedProducts(shared, owned) {
  const ids = new Set(owned.map((product) => product.id));
  const barcodes = new Set(owned.map((product) => product.barcode?.padStart(14, "0")));
  return shared.filter((product) => {
    const barcode = product.barcode.padStart(14, "0");
    if (ids.has(product.id) || barcodes.has(barcode)) return false;
    ids.add(product.id);
    barcodes.add(barcode);
    return true;
  });
}

// Discovery carries no tenant membership. Keep it distinct from stock-ready
// products, and retain only the reviewed public fields used by this screen.
export function sharedCatalogDiscovery(data) {
  const product = data?.shared_product;
  if (data?.source !== "shared_catalog" || data?.requires_catalog_add !== true
      || data?.product !== null || !product
      || ![product.id, product.barcode, product.name].every((value) => typeof value === "string" && value.trim())
      || !/^[a-f0-9]{64}$/.test(data.public_digest || "")) return null;
  return {
    product: publicPreview(product),
    digest: data.public_digest,
  };
}

export function scanContextKey(user, operationalContext) {
  return JSON.stringify([
    user?.id, user?.company_id, user?.role, user?.token_version,
    user?.store_id, user?.department_id,
    operationalContext?.storeId, operationalContext?.departmentId,
  ]);
}
